import { useDispatch } from "react-redux";
import { Navigate, useLocation } from "react-router-dom";
import { getFromStore, StoreType } from "services/localStorage";

const AuthGuard = ({ children }: { children: React.ReactNode }) => {
  const token = getFromStore(StoreType.AUTH_TOKEN);
  const dispatch = useDispatch();
  const { pathname } = useLocation();

  const isLoggedIn = !!token;

  const isAdminPath = pathname.startsWith("/admin");
  const isAdminLogin = pathname === "/admin/login";

  if (!isLoggedIn) {
    if (!isAdminLogin && isAdminPath) {
      dispatch({ type: "RESET_ALL_STATE" });
      localStorage.clear();
      return <Navigate to="/admin/login" replace />;
    } else if (!isAdminPath) {
      dispatch({ type: "RESET_ALL_STATE" });
      localStorage.clear();
      return <Navigate to="/auth/login" replace />;
    }
  }

  return children;
};

export default AuthGuard;
